import axios from "axios";

export default axios.create({
  baseURL: "https://uatapi.nextgenclarity.tech"
});
